module.exports = __webpack_public_path__ + "media/images/games/k2gender/racecardriver-0996500824fa2ff7e67862189a4d31f6.png";